var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "card--product",
      attrs: {
        href: _vm.permalink,
        "aria-label": _vm.name,
        "data-mh": "product-card",
      },
    },
    [
      _c("img", {
        staticClass: "card__image",
        attrs: { src: _vm.imageSrc, alt: _vm.imageAlt },
      }),
      _vm._v(" "),
      _vm.categories.length > 0
        ? _c("span", { staticClass: "card__terms" }, [
            _vm._v(_vm._s(_vm.getCategoryList)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("h4", { staticClass: "card__title" }, [_vm._v(_vm._s(_vm.name))]),
      _vm._v(" "),
      _vm.getAttributes.length > 0
        ? _c(
            "ul",
            { staticClass: "nav flex-column card__list--product-attrs" },
            _vm._l(_vm.getAttributes, function (attribute, index) {
              return _c("li", { key: index }, [
                _vm._v(
                  "\n      " +
                    _vm._s(attribute.label) +
                    ": " +
                    _vm._s(attribute.value) +
                    "\n    "
                ),
              ])
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }